const home = {
  heroTitle: "华丽的外出",
  heroSubtitle: "从穿搭到妆容，从配饰到仪态，全方位打造令人过目难忘的出行风格。让每一次外出都散发华丽气场，成为街头最耀眼的存在。",
  heroCTA: "探索穿搭灵感",
  categoriesTitle: "探索风格领域",
  categoriesSubtitle: "从穿搭到仪态，全方位打造你的华丽出行",
  featuredTitle: "精选穿搭文章",
  featuredSubtitle: "专业造型师为你精心挑选的时尚指南",
  faqTitle: "常见问题",
  faqSubtitle: "关于华丽穿搭，你想知道的都在这里",
  newsletterTitle: "订阅华丽资讯",
  newsletterSubtitle: "每周获取最新穿搭灵感与独家造型技巧，开启你的华丽之旅",
  viewAll: "查看全部",
  latestArticles: "最新文章",
  popularArticles: "热门推荐",
};

export default home;